/* eslint-disable no-useless-catch */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiget } from '../../service/api';

export const fetchProjectTypeData = createAsyncThunk('fetchProjectTypeData', async () => {
    const userid = sessionStorage.getItem('user_id');
    const userRole = sessionStorage.getItem("userRole");
    try {
        const response = await apiget('api/projecttypes/');
        return response?.data?.result;
    } catch (error) {
        throw error;
    }
});

const projectTypeSlice = createSlice({
    name: 'projectTypeDetails',
    initialState: {
        data: [],
        isLoading: false,
        error: "",
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProjectTypeData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchProjectTypeData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
                state.error = "";
            })
            .addCase(fetchProjectTypeData.rejected, (state, action) => {
                state.isLoading = false;
                state.data = [];
                state.error = action.error.message;
            });
    },
});

export default projectTypeSlice.reducer;